// import "./Global_footprint.css";
// import indiaFlag from "../assets/india-flag.png";
// import usaFlag from "../assets/us-flag.png";
// import euFlag from "../assets/europe-flag.png";
// import ukFlag from "../assets/uk-flag.png";
// import germanyFlag from "../assets/germany-flag.png";
// import plant1 from "../assets/img29.jpg";
// import plant2 from "../assets/img30.jpg";
// import plant3 from "../assets/img31.jpg";
// import WorldMap from "./WorldMap";

// const GlobalFootprints = () => {
//   return (
//     <div className="global-container" id="glo-foot">
//       <h2 className="global-title">Global Footprints</h2>
//       <div className="glo-underline"></div>
//       <div className="global-layout">
//         <div className="global-content">
//           <div className="global-left">
//             <div className="section">
//               <h3>3 Manufacturing Plants</h3>
//               <div className="plant-cards">
//                 <div className="plant-card">
//                   <img src={plant1} alt="Plant 1" className="plant-image" />

//                   <div className="plant-info">
//                     <div className="flag-row">
//                       <img src={indiaFlag} alt="India" className="flag" />
//                       <h4>Thervoy Kandigai</h4>
//                     </div>

//                     <p>Chennai, India</p>
//                   </div>
//                 </div>

//                 <div className="plant-card">
//                   <img src={indiaFlag} alt="India" className="flag" />
//                   <h4>Oragadam</h4>
//                   <p>Chennai<br />India</p>
//                 </div>
//                 <div className="plant-card">
//                   <img src={usaFlag} alt="USA" className="flag" />
//                   <h4>Ridgeville</h4>
//                   <p>South Carolina<br />USA</p>
//                 </div>
//               </div>
//             </div>

//             <div className="section">
//               <h3>Design Centre</h3>
//               <div className="design-box">
//                 <p className="city">Neckarsulm</p>
//                 <div className="country-box">
//                   <img src={germanyFlag} alt="Germany" className="flag" />
//                   <p className="country">Germany (near Stuttgart)</p>
//                 </div>
//               </div>
//             </div>

//             <div className="section">
//               <h3>JIT supplies to customers</h3>
//               <div className="plant-card1">
//                 <p className="subtext">11 Third-Party Logistics (3PL) locations</p>
//                 <div className="jit-flags">
//                   <div className="jit-flag">
//                     <img src={usaFlag} alt="US" />
//                     <p className="country">US (2)</p>
//                   </div>
//                   <div className="jit-flag">
//                     <img src={euFlag} alt="EU" />
//                     <p className="country">EU (2 - SE, DE)</p>
//                   </div>
//                   <div className="jit-flag">
//                     <img src={ukFlag} alt="UK" />
//                     <p className="country">UK (1)</p>
//                   </div>
//                   <div className="jit-flag">
//                     <img src={indiaFlag} alt="India" />
//                     <p className="country">India (6)</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="global-map">
//           <WorldMap />
//         </div>
//       </div>

//       <div className="plant-gallery">
//         <img src={plant1} alt="Plant 1" />
//         <img src={plant2} alt="Plant 2" />
//         <img src={plant3} alt="Plant 3" />
//       </div>
//     </div>
//   );
// };

// export default GlobalFootprints;


import "./Global_footprint.css";
import indiaFlag from "../assets/india-flag.png";
import usaFlag from "../assets/us-flag.png";
import euFlag from "../assets/europe-flag.png";
import ukFlag from "../assets/uk-flag.png";
import germanyFlag from "../assets/germany-flag.png";
import plant1 from "../assets/img29.png";
import plant2 from "../assets/img31.png";
import plant3 from "../assets/img30.png";
import plant4 from "../assets/img31m.jpg";
import designCentreImage from "../assets/img32.png";
import WorldMap from "./WorldMap";
import Footer from "./Footer";

const GlobalFootprints = () => {
  return (
    <section id="glo-foot">
      <div className="global-container">
        <h2 className="global-title">Global Footprints</h2>
        <div className="glo-underline"></div>
        <div className="global-map">
          <WorldMap />
        </div>
        <div className="global-layout">
          <div className="global-content">
            <div className="global-left">
              <div className="section">
                <h3>4 Manufacturing Plants</h3>

                {/* PLANT CARDS WRAPPER */}
                <div className="plant-cards">
                  {/* Card 1 */}
                  <div className="plant-card">
                    <div className="plant-image-wrap">
                      <img src={plant1} alt="Thervoy Kandigai" className="plant-image" />
                    </div>
                    <div className="plant-info horizontal">
                      <img src={indiaFlag} alt="India" className="flag-large" />
                      <div className="text-block">
                        <h4 className="plant-title">Thervoy Kandigai</h4>
                        <p className="location">Chennai, India</p>
                      </div>
                    </div>

                  </div>

                  {/* Card 2 */}
                  <div className="plant-card">
                    <div className="plant-image-wrap">
                      <img src={plant2} alt="Oragadam" className="plant-image" />
                    </div>

                    <div className="plant-info horizontal">
                      <img src={indiaFlag} alt="India" className="flag-large" />
                      <div className="text-block">
                        <h4 className="plant-title">Oragadam</h4>
                        <p className="location">Chennai, India</p>
                      </div>
                    </div>
                  </div>
                  {/* Card 3 */}
<div className="plant-card">
  <div className="plant-image-wrap">
    <img src={plant4} alt="New Plant" className="plant-image" />
  </div>
  <div className="plant-info horizontal">
    <img src={indiaFlag} alt="India" className="flag-large" />
    <div className="text-block">
      <h4 className="plant-title">Mahindra World City India</h4>
      <p className="location">Chennai, India</p>
    </div>
  </div>
</div>
                  {/* Card 4 */}
                  <div className="plant-card">
                    <div className="plant-image-wrap">
                      <img src={plant3} alt="Ridgeville" className="plant-image" />
                    </div>
                    <div className="plant-info horizontal">
                      <img src={usaFlag} alt="USA" className="flag-large" />
                      <div className="text-block">
                        <h4 className="plant-title">Ridgeville</h4>
                        <p className="location">South Carolina, USA</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

             <div className="globe-sec">
             <div className="globe-sec1">
               <div className="section">
               <h3>Design Centre</h3>
                <div className="design-box">
              <div className="design-image-wrap">
          <img src={designCentreImage} alt="Neckarsulm Design Centre" className="design-image" />
        </div>

        <div className="plant-info horizontal">
          <img src={germanyFlag} alt="Germany" className="flag-large" />
          <div className="text-block">
            <h4 className="plant-title">Neckarsulm</h4>
            <p className="location">Germany (near Stuttgart)</p>
          </div>
        </div>
      </div>
    </div>

                  <div className="section">
                    <h3>JIT supplies to customers</h3>
                    <div className="plant-card1">
                      <p className="subtext">11 Third-Party Logistics (3PL) locations</p>
                      <div className="jit-flags">
                        <div className="jit-flag">
                          <img src={usaFlag} alt="US" />
                          <p className="country">US (2)</p>
                        </div>
                        <div className="jit-flag">
                          <img src={euFlag} alt="EU" />
                          <p className="country">EU (2 - SE, DE)</p>
                        </div>
                        <div className="jit-flag">
                          <img src={ukFlag} alt="UK" />
                          <p className="country">UK (1)</p>
                        </div>
                        <div className="jit-flag">
                          <img src={indiaFlag} alt="India" />
                          <p className="country">India (6)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>


        </div>

      </div>
      <Footer />
    </section>
  );
};

export default GlobalFootprints;
